export default [
	{
		path: '/maps/:slug',
		lazy: async () => {
			const Module = await import('../../pages/project/LegacyMapRedirect');
			return { Component: Module.default };
		},
	},
];
